import { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

import { ReduxStates } from "Types";
import { Data as DataType } from "Types/Reducers";

import AtomText from "Components/Atoms/Text";
import AtomStep1Title from "Components/Atoms/Step1Title";
import OrganismForm1 from "Components/Organisms/Form1";
import OrganismForm2 from "Components/Organisms/Form1-2";
import OrganismForm3 from "Components/Organisms/Form1-3";
import AtomButton from "Components/Atoms/Button";

export type PropsType = any;

const Wrap = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
`;

const Text = styled(AtomText)`
   margin-top: 40px;
   text-align: center;
   line-height: 25px;
`;

const Form1 = styled(OrganismForm1)`
   margin-top: 50px;
`;

const Form2 = styled(OrganismForm2)`
   margin-top: 20px;
`;
const Form3 = styled(OrganismForm3)`
   margin-top: 20px;
`;
const Button = styled(AtomButton)<any>`
   margin-top: 35px;
`;

export default function TemplateStep1(props: PropsType) {
   const data = useSelector((state: any) => state.data);
   const [agree, setAgree] = useState(false);
   const buttonDisabled = data.v_name && data.email && data.hp && agree;

   return (
      <Wrap>
         <AtomStep1Title>전시회 등록을 환영합니다</AtomStep1Title>
         <Text t={"t3"}>
            <p>아트맵에 전시회 자료를 등록해주셔서 감사합니다.</p>
            <p>등록하신 자료는 전시 등록 지원팀이 확인 후 아트맵 Web/APP 서비스에 게재됩니다.</p>
         </Text>
         <Form1></Form1>
         <Form2 checkValue={agree} checkOnChange={(ev: any) => setAgree(ev.target.checked)}></Form2>
         <Form3></Form3>
         <Button onClick={props.nextOnClick} disabled={!buttonDisabled}>
            다음
         </Button>
      </Wrap>
   );
}
